import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserRole } from '../models/user-role';
import { GridConfiguration } from '../models/grid-configuration';
import { DefaultGridConfiguration } from '../models/default-grid-configuration';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class GridConfigurationService {

    constructor(private httpService: JsonHttpService) { }

    getGridConfigurations(name: string, key: string, includeSystemConfigurations: boolean): Promise<GridConfiguration[]> {
        const options = {
            params: new HttpParams()
                .set('includeSystemConfigurations', `${includeSystemConfigurations}`)
        };
        if (name != null) {
            options.params = options.params.set('name', name);
        }
        if (key != null) {
            options.params = options.params.set('key', key);
        }

        return this.httpService.get('api/users/gridconfiguration/get-gridconfiguration', options).toPromise();
    }

    saveGridConfiguration(config: GridConfiguration): Promise<GridConfiguration> {
        return this.httpService.post('api/users/gridconfiguration/save-gridconfiguration', config).toPromise();
    }

    setDefaultView(defaultConfig: DefaultGridConfiguration): Promise<GridConfiguration> {
        return this.httpService.post('api/users/gridconfiguration/set-default-view', defaultConfig).toPromise();
    }

    removeDefaultView(defaultConfig: DefaultGridConfiguration): Promise<GridConfiguration> {
        return this.httpService.post('api/users/gridconfiguration/remove-default-view', defaultConfig).toPromise();
    }

    getDefaultViews(key: string): Promise<GridConfiguration[]> {
        const options = { params: new HttpParams().set('key', `${key}`) };
        return this.httpService.get('api/users/gridconfiguration/get-default-views', options).toPromise();
    }

    deleteGridConfiguration(configId: number): Promise<GridConfiguration> {
        return this.httpService.post('api/users/gridconfiguration/delete-gridconfiguration', configId).toPromise();
    }
}
